export const pushStoreCode = (code: string): void => {
  window?.dataLayer?.push({
    'RUSq': code,
  });
};
